import type { GeoBoundaries, GeoLocation, RadiusOption } from "../types/geo";

const GERMAN_INDEX = process.env.NEXT_PUBLIC_INDEX_GERMAN;
const ENGLISH_INDEX = process.env.NEXT_PUBLIC_INDEX_ENGLISH;
const SPANISH_INDEX = process.env.NEXT_PUBLIC_INDEX_SPANISH;
const FRENCH_INDEX = process.env.NEXT_PUBLIC_INDEX_FRENCH;
const HUNGARIAN_INDEX = process.env.NEXT_PUBLIC_INDEX_HUNGARIAN;
const CHINESE_INDEX = process.env.NEXT_PUBLIC_INDEX_CHINESE;
const PORTUGUESE_INDEX = process.env.NEXT_PUBLIC_INDEX_PORTUGUESE;
const ROMANIAN_INDEX = process.env.NEXT_PUBLIC_INDEX_ROMANIAN;
const SWEDISH_INDEX = process.env.NEXT_PUBLIC_INDEX_SWEDISH;
const TCHECH_INDEX = process.env.NEXT_PUBLIC_INDEX_TCHECH;
const DUTCH_INDEX = process.env.NEXT_PUBLIC_INDEX_DUTCH;
const TAIWANESE_INDEX = process.env.NEXT_PUBLIC_INDEX_TAIWANESE;
const ITALIAN_INDEX = process.env.NEXT_PUBLIC_INDEX_ITALIAN;
const POLISH_INDEX = process.env.NEXT_PUBLIC_INDEX_POLISH;

const GERMAN_EVENT_INDEX = process.env.NEXT_PUBLIC_EVENT_INDEX_GERMAN;
const ENGLISH_EVENT_INDEX = process.env.NEXT_PUBLIC_EVENT_INDEX_ENGLISH;
const SPANISH_EVENT_INDEX = process.env.NEXT_PUBLIC_EVENT_INDEX_SPANISH;
const FRENCH_EVENT_INDEX = process.env.NEXT_PUBLIC_EVENT_INDEX_FRENCH;
const HUNGARIAN_EVENT_INDEX = process.env.NEXT_PUBLIC_EVENT_INDEX_HUNGARIAN;
const CHINESE_EVENT_INDEX = process.env.NEXT_PUBLIC_EVENT_INDEX_CHINESE;
const PORTUGUESE_EVENT_INDEX = process.env.NEXT_PUBLIC_EVENT_INDEX_PORTUGUESE;
const ROMANIAN_EVENT_INDEX = process.env.NEXT_PUBLIC_EVENT_INDEX_ROMANIAN;
const SWEDISH_EVENT_INDEX = process.env.NEXT_PUBLIC_EVENT_INDEX_SWEDISH;
const TCHECH_EVENT_INDEX = process.env.NEXT_PUBLIC_EVENT_INDEX_TCHECH;
const DUTCH_EVENT_INDEX = process.env.NEXT_PUBLIC_EVENT_INDEX_DUTCH;
const TAIWANESE_EVENT_INDEX = process.env.NEXT_PUBLIC_EVENT_INDEX_TAIWANESE;
const ITALIAN_EVENT_INDEX = process.env.NEXT_PUBLIC_EVENT_INDEX_ITALIAN;
const POLISH_EVENT_INDEX = process.env.NEXT_PUBLIC_EVENT_INDEX_POLISH;

// Maybe we can refactor this as well with a list index from mongo -> maybe typesense has a similar feature?

// Checks the chosen language and returns the corresponding Algolia index.
// biome-ignore lint/complexity/noExcessiveCognitiveComplexity: <static statements>
export function getIndexForLocale(locale: string, isEvent?: boolean): string {
  const throwError = () => {
    throw new Error(`The index for locale ${locale} is undefined. Check .env?`);
  };

  if (isEvent) {
    switch (locale) {
      case "de":
        return GERMAN_EVENT_INDEX || throwError();
      case "en":
        return ENGLISH_EVENT_INDEX || throwError();
      case "es":
        return SPANISH_EVENT_INDEX || throwError();
      case "fr":
        return FRENCH_EVENT_INDEX || throwError();
      case "hu":
        return HUNGARIAN_EVENT_INDEX || throwError();
      case "zh":
        return CHINESE_EVENT_INDEX || throwError();
      case "cn":
        return CHINESE_EVENT_INDEX || throwError();
      case "pt":
        return PORTUGUESE_EVENT_INDEX || throwError();
      case "ro":
        return ROMANIAN_EVENT_INDEX || throwError();
      case "sv":
        return SWEDISH_EVENT_INDEX || throwError();
      case "cs":
        return TCHECH_EVENT_INDEX || throwError();
      case "tw":
        return TAIWANESE_EVENT_INDEX || throwError();
      case "nl":
        return DUTCH_EVENT_INDEX || throwError();
      case "it":
        return ITALIAN_EVENT_INDEX || throwError();
      case "pl":
        return POLISH_EVENT_INDEX || throwError();
      default:
        return GERMAN_EVENT_INDEX || throwError();
    }
  }

  switch (locale) {
    case "de":
      return GERMAN_INDEX || throwError();
    case "en":
      return ENGLISH_INDEX || throwError();
    case "es":
      return SPANISH_INDEX || throwError();
    case "fr":
      return FRENCH_INDEX || throwError();
    case "hu":
      return HUNGARIAN_INDEX || throwError();
    case "zh":
      return CHINESE_INDEX || throwError();
    case "cn":
      return CHINESE_INDEX || throwError();
    case "pt":
      return PORTUGUESE_INDEX || throwError();
    case "ro":
      return ROMANIAN_INDEX || throwError();
    case "sv":
      return SWEDISH_INDEX || throwError();
    case "cs":
      return TCHECH_INDEX || throwError();
    case "nl":
      return DUTCH_INDEX || throwError();
    case "tw":
      return TAIWANESE_INDEX || throwError();
    case "it":
      return ITALIAN_INDEX || throwError();
    case "pl":
      return POLISH_INDEX || throwError();
    default:
      return GERMAN_INDEX || throwError();
  }
}

export function getCollectionNameForLocale(
  locale: string,
  isEvent?: boolean
): string {
  if (isEvent) {
    return getIndexForLocale(locale, true);
  }
  return getIndexForLocale(locale);
}

export function isLoadingBoundaries(
  geoLocation?: GeoLocation,
  radius?: RadiusOption,
  boundaries?: GeoBoundaries
): boolean {
  if (!(geoLocation && radius)) {
    // Not using geo search
    return false;
  }

  if (radius.value !== 0) {
    // Not using boundaries
    return false;
  }

  // No boundaries or wrong boundaries
  return !boundaries || boundaries.placeId !== geoLocation.placeId;
}
